import React, {useContext, useEffect, useState} from 'react';
import {alpha} from '@mui/material/styles';
import {Avatar, Box, Divider, IconButton, MenuItem, Popover, Typography} from '@mui/material';
import {useNavigate} from "react-router-dom";
import UserContext from "../../../UserContext";
import DialogIdentification from "../../../sections/@dashboard/dialog-identification/DialogIdentification";
import DialogImageUpload from "../../../sections/@dashboard/dialog/DialogImageUpload";
import {config} from "../../../constant";

// ----------------------------------------------------------------------

// const MENU_OPTIONS = [
//   {
//     label: 'Home',
//     icon: 'eva:home-fill',
//   },
//   {
//     label: 'Profile',
//     icon: 'eva:person-fill',
//   },
//   {
//     label: 'Settings',
//     icon: 'eva:settings-2-fill',
//   },
// ];

// ----------------------------------------------------------------------

export default function AccountPopover() {
    const [open, setOpen] = useState(null);
    const {user, setUser} = useContext(UserContext);
    const [identificationDialogOpen, setIdentificationDialogOpen] = useState(false);
    const [avatarUrl, setAvatarUrl] = useState();
    const [imageDialogOpen, setImageDialogOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            fetch(`${config.BASE_URL}/people/${user.id}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`${response.status} ${response.statusText}`)
                    }
                    return response.json();
                }).then(data => {
                    if (data.avatar) {
                        setAvatarUrl(`data:${data.avatar.contentType};base64,${data.avatar.data}`);
                    }
                }).catch(error => {
                    const message = 'Erreur dans la récupération de l\'utilisateur';
                    console.error(message, error);
                    navigate("/error", {state: {message: message}});
                });
        } else {
            setAvatarUrl('/assets/images/avatars/avatar_24.jpg');
        }
    }, [user]);

    const handleOpen = (event) => {
        if (user) {
            setOpen(event.currentTarget);
        } else {
            setIdentificationDialogOpen(true);
        }
    };

    return (
        <>
            <IconButton
                onClick={handleOpen}
                sx={{
                    p: 0,
                    ...(open && {
                        '&:before': {
                            zIndex: 1,
                            content: "''",
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            position: 'absolute',
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
                        },
                    }),
                }}
            >
                <Avatar src={avatarUrl} alt="Avatar" />
            </IconButton>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={() => setOpen(null)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                PaperProps={{
                    sx: {
                        p: 0,
                        mt: 1.5,
                        ml: 0.75,
                        width: 180,
                        '& .MuiMenuItem-root': {
                            typography: 'body2',
                            borderRadius: 0.75,
                        }
                    }
                }}
            >
                {user && (
                    <>
                        <Box sx={{my: 1.5, px: 2.5}}>
                            <Typography variant="subtitle2" noWrap>
                                {user.firstName}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                                {user.email}
                            </Typography>
                        </Box>
                        <MenuItem
                            onClick={() => {
                                setOpen(null);
                                setImageDialogOpen(true);
                            }}
                            sx={{m: 1}}>
                            Avatar
                        </MenuItem>
                    </>
                )}

        {/*<Stack sx={{ p: 1 }}>*/}
        {/*  {MENU_OPTIONS.map((option) => (*/}
        {/*    <MenuItem key={option.label} onClick={handleIdentificationClose}>*/}
        {/*      {option.label}*/}
        {/*    </MenuItem>*/}
        {/*  ))}*/}
        {/*</Stack>*/}

                <Divider sx={{borderStyle: 'dashed'}} />

                <MenuItem
                    onClick={() => {
                      setOpen(null);
                      setIdentificationDialogOpen(true);
                    }}
                    sx={{m: 1}}>
                    Changer
                </MenuItem>

        {/*<MenuItem onClick={handleClose} sx={{ m: 1 }}>*/}
        {/*  Logout*/}
        {/*</MenuItem>*/}
            </Popover>

            {identificationDialogOpen && (
                <DialogIdentification open={identificationDialogOpen} onClose={() => setIdentificationDialogOpen(false)}>
                </DialogIdentification>
            )}

            {imageDialogOpen && (
                <DialogImageUpload
                    open={imageDialogOpen}
                    onClose={image => {
                        setImageDialogOpen(false);
                        setUser(values => ({...values, 'avatar': image}));
                    }}
                    id={user.id}>
                </DialogImageUpload>
            )}
    </>
  );
}
